import React, { useState, useEffect } from 'react';
import { segmentTrackEvent } from '../utils';
import MainRecipe from './MainRecipe';
import SecondaryRecipe from './SecondaryRecipe';
import Shop from './Shop';

const handleSubSectionLinkClick = (e) => {
  const { target } = e;
  const targetTagName = target.tagName.toLowerCase();
  let trackableElement = target;
  let innerHTML = '';
  if ((targetTagName === 'a') || ((targetTagName === 'img') && (target.parentNode.tagName.toLowerCase() === 'a')) || this.props.dataEventName) {
    if (targetTagName === 'img') {
      trackableElement = target.parentNode;
      innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
    } else {
      ({ innerHTML } = target);
    }
  }
  const destinationUrl = trackableElement.getAttribute('href');
  const linkType = trackableElement.getAttribute('data-link-type') || 'text-link';
  const articleClickedTracker = {
    destinationUrl,
    module: 'sub-section',
    category: linkType,
    linkType,
    label: `${innerHTML} hyperlink`,
  };
  segmentTrackEvent('article_link_clicked', articleClickedTracker);
};

const Section = ({
  section,
  sectionIndex,
  handleClick,
  isMobile,
}) => {
  const { navHed, headerImage, type, footerImage, hedUrl, nextSectionText } = section;

  const stickyNavHed = isMobile ? navHed.mobile : navHed.desktop;

  const [showSection, setShowSection] = useState(false);
  const [sticky, setSticky] = useState(false);
  const nextSection = ( sectionIndex === 5 ) ? 0 : sectionIndex + 1;

  const closeTracker = {
    module: 'section',
    category: 'close-section',
    linkType: 'close-section',
    label: `close-${type}`,
  };
  const sectionTracker = {
    module: 'section',
    category: 'open-section',
    linkType: 'open-section',
    label: `open-next-section-from-${section.type}`,
  };
  // const subSectionHeaderTracker = {
  //   destinationUrl: hedUrl,
  //   module: 'section',
  //   category: 'text-link',
  //   linkType: 'text-link',
  //   label: navHed,
  // };

  useEffect(() => {
    const handleScroll = () => {
      window.scrollY > 0 ? setSticky(true) : setSticky(false);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sticky]);

  // modules within a section
  const renderedSubSections = section.subSections.map((subSection, i) => {
    const { moduleType, title, type } = subSection;
    const trackingLabel = `${title} hyperlink`;
    const subSectionClass = (moduleType === 'shop') ? `sub-section shop section-${i}` : `sub-section section-${i}`;
    const textLinkTracker = {
      destinationUrl: trackingLabel,
      module: 'section',
      category: 'text-link',
      linkType: 'text-link',
      label: title,
    };
    return (
        <div className={subSectionClass} id={i} key={i}>
          {moduleType === 'main-recipe'
            && <MainRecipe subSection={subSection} type={type} sectionIndex={sectionIndex} isMobile={isMobile} />}
          {moduleType === 'shop'
            && <Shop subSection={subSection} type={type} sectionIndex={sectionIndex} isMobile={isMobile} />}
          {moduleType === 'secondary-recipe'
            && <SecondaryRecipe subSection={subSection} type={type} sectionIndex={sectionIndex} isMobile={isMobile} />}
        </div>
    );
  });

  const nextSectionCTAClass = `next-section-cta ${type}`;

  return (
      <div className="section-container">
        <div id="section" className={`section ${section.type}`}>
          <div className={`sub-section-container ${sticky ? 'sticky' : ''}`}>
            <div className={`sub-section-hed-container ${section.type} ${sticky ? 'sticky' : ''}`}>
              <h2 className={`sub-section-hed ${section.type}-hed`} dangerouslySetInnerHTML={{ __html: stickyNavHed }}></h2>
              <div className={`section-button-x section-${sectionIndex}`} onClick={() => { segmentTrackEvent('article_clicked', closeTracker); handleClick(null, true); }}></div>
            </div>
            <img className="sub-section-header-img" src={isMobile ? headerImage.mobile : headerImage.desktop} />
            <div className="sub-sections-wrapper">
              {renderedSubSections}
            </div>
            <button className={nextSectionCTAClass} onClick={() => { segmentTrackEvent('end_of_section_button_clicked', sectionTracker); handleClick(nextSection, false); }}>{nextSectionText}</button>
            <img className="sub-section-footer-img" src={isMobile ? footerImage.mobile : footerImage.desktop} />
          </div>
        </div>
      </div>
  );
};

export default Section;
